import classNames from "classnames";
import Container from "reactstrap/es/Container";
import NavBar from "./Navbar";

function Content (props) {
	return (
		<Container fluid className={classNames('content', { 'is-open': props.isOpen })}>
			<NavBar toggle={props.toggle} />
			{props.children}
		</Container>
	);
}

export default Content;
